import { ListScreenFiltersConfig } from '@components/v2/layout/ListScreen/listScreen.types';
import { UseOrderFilterV2Result } from '../../../orderFilter/hooks/useOrderFilterV2';
import { ORDERS_FILTERS_KEYS } from '../../../orderFilter/orderFilter.utils';

export const isArchivedOrderFilterActive = (searchParams: Record<string, any>): boolean =>
  searchParams[ORDERS_FILTERS_KEYS.archivedOrder] === 'true';

export const toListScreenFilters = (
  filters?: UseOrderFilterV2Result,
): ListScreenFiltersConfig | undefined =>
  filters && {
    options: filters.options,
    preferenceList: filters.list,
    columnsVisibility: filters.columnsVisibility,
    fixedFilters: filters.fixedFilters,
    searchField: filters.searchField,
    isSearchActive: filters.isSearchActive,
    onClearSearch: filters.onClearSearch,
  };
